@if (teachers.length > 0) {
<div class="grid grid-flow-row-dense lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-x-4 gap-y-16">
    @for(teacher of teachers; track $index){
    <teacher-card [teacher]="teacher"></teacher-card>
    }
</div>
}